export class ManagementToastTimer {
  private timeout: ReturnType<typeof setTimeout> | null = null;

  schedule(callback: () => void, afterDismiss?: () => void, delay = 3000) {
    this.clear();
    this.timeout = setTimeout(() => {
      callback();
      this.timeout = null;
      afterDismiss?.();
    }, delay);
  }

  clear() {
    if (!this.timeout) {
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = null;
  }
}
